const PP_CLUSTER_CONTRACT = 'PP (Cluster)';
const RN_ONLY_CLUSTER_PACKAGES = ['RN Routine Visit', 'Med 1'];

function matchKey(value: unknown): string {
  return String(value ?? '').trim().replace(/[^a-z0-9]/gi, '').toLowerCase();
}

function values(value: unknown): string[] {
  if (Array.isArray(value)) return value.map((item) => String(item).trim()).filter(Boolean);
  return String(value ?? '').split(';').map((item) => item.trim()).filter(Boolean);
}

export function hasPpClusterContract(contractTypes: unknown): boolean {
  return values(contractTypes).some((contractType) => matchKey(contractType) === matchKey(PP_CLUSTER_CONTRACT));
}

export function shouldRequireClusterPackagesOnPlanOfCare(data: Record<string, unknown>): boolean {
  if (!hasPpClusterContract(data.contractTypes)) return false;
  if (['Aide Supervision/Evaluation', 'Patient Evaluation'].some((visitType) => (
    matchKey(data.visitType) === matchKey(visitType)
  ))) return false;
  if (matchKey(data.visitType) !== matchKey('Revisit')) return true;
  return matchKey(data.isPocUpdateNeeded) === matchKey('Yes');
}

export function isRnOnlyClusterAssessment(data: Record<string, unknown>): boolean {
  const contractTypes = values(data.contractTypes);
  if (contractTypes.length !== 1 || matchKey(contractTypes[0]) !== matchKey(PP_CLUSTER_CONTRACT)) return false;

  const clusterPackages = values(data.clusterPackages);
  return clusterPackages.length > 0 && clusterPackages.every((clusterPackage) => (
    RN_ONLY_CLUSTER_PACKAGES.some((allowedPackage) => matchKey(clusterPackage) === matchKey(allowedPackage))
  ));
}
